module.exports = __webpack_public_path__ + "static/img/350.8ebc567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/350.jpg
// module id = g+Ul
// module chunks = 52